module.exports = __webpack_public_path__ + "img/img918.3782404e.png";